import { render, staticRenderFns } from "./info-user.vue?vue&type=template&id=041bf970&"
import script from "./info-user.vue?vue&type=script&lang=js&"
export * from "./info-user.vue?vue&type=script&lang=js&"
import style0 from "./info-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports